import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppSelector } from '../hooks';
import { selectAuthUser } from '../reducers/auth/authSlice';

export const PrivateRoutes = () => {
    const { authToken } = useAppSelector(selectAuthUser);
    const location = useLocation();

    return authToken ? (
        <Outlet />
    ) : (
        <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />
    );
};
